<app-dialog-base [titleTranslationKey]="title">
  <ng-container content>
    <div class="info-text">
      {{ text }}
    </div>
  </ng-container>

  <ng-container actions>
    <button mat-flat-button color="primary" (click)="onOk()" mat-button>{{ 'shared.ok' | translate | uppercase }}</button>
  </ng-container>
</app-dialog-base>
